import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish } from 'types';

interface DishSatelliteConnection {
  dish_id: number;
  satellite_id: number;
}

export const connectDishToSatellite = (
  data: DishSatelliteConnection
): Promise<Dish> => {
  return axios.post(
    `/api/dishes/${data.dish_id}/connect-satellite/${data.satellite_id}`
  );
};

type UseConnectDishToSatelliteOptions = {
  config?: MutationConfig<typeof connectDishToSatellite>;
};

export const useConnectDishToSatellite = ({
  config,
}: UseConnectDishToSatelliteOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['systemOverview']);
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['satellites']);
    },
    ...config,
    mutationFn: connectDishToSatellite,
  });
};
